<template>
    <b-button variant="warning" @click.stop="confirmar()" v-if="mostrarBtn">
        <i class="fa fa-exclamation-triangle mr-2"></i>Definir como
        {{ finalizacao.prioritario ? 'não ' : '' }}prioritário
    </b-button>
</template>

<script>
import { finalizacoesStatus } from './FinalizacoesStatus'

export default {
    props: {
        finalizacao: {
            type: Object,
            default: () => {}
        },

        finalizacoesServicos: {
            type: Object,
            required: true
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmar() {
            this.$swal({
                title: 'Registro de Pagamento',
                html: `Confirma a ${
                    this.finalizacao.prioritario ? 'não ' : ''
                }definição do registro de pagamento ${
                    this.finalizacao.protocolo
                } como prioritário?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            this.finalizacoesServicos
                .definirPrioritario(this.finalizacao.finalizacaoId)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterFinalizacaoAtualizada')
                        } else {
                            this.$toast.error(
                                'Erro ao atualizar registro de pagamento!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    created() {},

    computed: {
        mostrarBtn() {
            return (
                this.$temAcessoView('CRED-UABS-FIN-08') &&
                (this.finalizacao.status == finalizacoesStatus.EM_APROVACAO ||
                    this.finalizacao.status ==
                        finalizacoesStatus.REPROVADA_PELO_SETOR_FINANCEIRO)
            )
        }
    },

    watch: {},

    validations: {}
}
</script>
